class Send_Notification {
    static path = 'other-actions/send-notification';

    constructor(mutator){
        this.addInput("Determining Condition", "boolean");
        this.addInput("User", "user,user_id");
        this.addInput("Message", "string");
        this.bgcolor = '#9dffaa';
        this.title = 'Send Notification';
        this.desc = 'Send a notification to a user.';
    }

}

module.exports = Send_Notification
